/**
 * Google Analytics loader - only loads after GDPR consent
 */
import { log } from './logger';

const GA_TRACKING_ID = 'UA-178649497-1';

let gaInitialized = false;

/**
 * Dynamically loads Google Analytics script
 * Should only be called after user consent
 */
export const initializeGA = () => {
  if (gaInitialized) {
    return;
  }

  // Create and inject the gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_TRACKING_ID);

  gaInitialized = true;
  log('Google Analytics initialized after consent');
};

/**
 * Check if user has already consented (cookie exists)
 * @returns {boolean}
 */
export const hasGdprConsent = () => {
  return document.cookie.split(';').some((cookie) => cookie.trim().startsWith('CookieConsent='));
};

/**
 * Initialize GA if consent was previously given
 * Call this on app startup
 */
export const initializeGAIfConsented = () => {
  if (hasGdprConsent()) {
    initializeGA();
  }
};
